import { render, staticRenderFns } from "./RedPacketRecords.vue?vue&type=template&id=2568fbc4&scoped=true"
import script from "./RedPacketRecords.vue?vue&type=script&lang=js"
export * from "./RedPacketRecords.vue?vue&type=script&lang=js"
import style0 from "./RedPacketRecords.vue?vue&type=style&index=0&id=2568fbc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2568fbc4",
  null
  
)

export default component.exports